export const WAITING_TO_START = 1
export const WAITING_ON_DATA = 2
export const WAITING_ON_PROCESSOR = 3
export const PROCESSING = 4
export const VALIDATING = 5
export const EXPORTING_DATA = 6
export const COMPLETED = 7
export const GENERATING_CLASSIFICATION = 8
